import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const percentOffFlagSaleSelector = createSelector(testTargetOffersSelector, offers => offers.percentOffFlagSale || Empty.Object);

export { percentOffFlagSaleSelector };
